module.exports = __webpack_public_path__ + "static/media/Scenario3Header.b376300b.jpg";